var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrompts = function SvgPrompts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 21.644 17.946 20.6l1.825-1.85H15.25v-1.5h4.521l-1.825-1.85L19 14.356 22.644 18zm-16.75-.25V5.058q0-.748.53-1.278t1.278-.53h14.884q.749 0 1.278.53.53.53.53 1.278v6.988a3 3 0 0 0-.375-.038 9 9 0 0 0-.75 0 3 3 0 0 0-.375.038V5.058a.3.3 0 0 0-.087-.221.3.3 0 0 0-.22-.087H4.057a.3.3 0 0 0-.221.087.3.3 0 0 0-.087.22V17.25h9.296q-.03.192-.038.375a9 9 0 0 0 0 .75q.008.183.038.375H4.894zM6.058 8.5h10.884V7H6.058zm0 6.5h6.884v-1.5H6.058z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.942 11.755H6.058v-1.5h10.884z"
  })));
};
export default SvgPrompts;